import { IFetchResponse } from 'lib/requests/fetch';
import _ from 'lodash';

export const triggerDownload = (params: { filename: string; url: string }) => {
  const a = document.createElement('a');
  a.href = params.url;
  a.download = params.filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const downloadFile = (params: {
  response: IFetchResponse<any>;
  fallbackFilename: string;
}) => {
  const contentDisposition = _.first(
    params.response.headers['content-disposition']
  );
  const matches = /filename="([^"]*)"/.exec(contentDisposition);
  const filename = (matches && matches[1]) || params.fallbackFilename;
  const url = window.URL.createObjectURL(params.response.data);
  triggerDownload({ filename, url });
  window.URL.revokeObjectURL(url);
};

export const downloadJson = async (params: {
  data: unknown;
  filename: string;
}) => {
  const jsonString = JSON.stringify(params.data, null, 2);
  const url = window.URL.createObjectURL(
    new Blob([jsonString], { type: 'application/json' })
  );
  triggerDownload({ filename: params.filename, url });
  window.URL.revokeObjectURL(url);
};
